
import axios from "axios"
import router from "./router"
import store from "@/store"

// set the base URL to the current location, ignoring any ports used for development/debugging
axios.defaults.baseURL = `${window.location.protocol}//${window.location.hostname}`

/**
 * If we have a token, send it with the request.
 */
axios.interceptors.request.use(request => {
    const token = store.state.token

    if (token && token.token) {
        request.headers.common["X-Authorization"] = token.token
    }

    return request
}, error => {
    return Promise.reject(error)
})

/**
 * If the server informs us the token is invalid, unauthenticate the current user and go to the
 * login page. Also prevents Axios from throwing errors.
 */
axios.interceptors.response.use(function (response) {
    if (response.data !== undefined && response.data !== null) {
        return response.data
    } else {
        return response
    }
}, function (error) {
    if (error.response) {
        const tokenGone = !!error.response.headers["x-token-gone"]

        if (tokenGone === true) {
            store.commit("unsetAuth")

            router.push("/login")
        }

        return Promise.reject(error.response.data.data)
    } else {
        return Promise.reject(error)
    }
})

export default axios



// WEBPACK FOOTER //
// ./src/http.js